import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import DressDetail from "@/pages/DressDetail";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import { ImpressumPage, DatenschutzPage } from "@/pages/LegalPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/kleider" element={<Catalog />} />
            <Route path="/kleid/:id" element={<DressDetail />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors theme="light" />
      </AuthProvider>
    </div>
  );
}

export default App;
